export default __webpack_public_path__ + "static/media/10_Clone.49a217c9.webp";